<template>
  <v-container fluid>
    <PageHeaderSlot />

    <v-form ref="dataForm" @submit.prevent="">
      <v-card>
        <v-card-text class="px-2">
          <v-row class="ma-0">
            <v-col cols="12">
              <QuillEditor :html.sync="formData.content" editorID="content" label="content" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <div class="d-flex align-center mt-4">
        <FormButton @click="save()" />
      </div>
    </v-form>
  </v-container>
</template>

<script>
import QuillEditor from '@/components/formField/QuillEditor.vue'

export default {
  name: 'CustomPage',
  components: {
    QuillEditor,
  },
  computed: {
    fieldName() {
      switch (this.$route.name) {
        case 'AboutUs':
          return 'about_us'
        case 'UsefulLinks':
          return 'useful_links_edit'
        case 'FestivalPromotions':
          return 'promotions_edit'
        case 'Faq':
          return 'faq_edit'
        case 'Collaborations':
          return 'sponsor_edit'
      }
      return ''
    },
  },
  data: () => ({
    formData: {
      content: '',
    },
  }),
  methods: {
    async getSetting() {
      try {
        const data = await this.$Fetcher.GetSetting()
        if (this.$validate.DataValid(this.fieldName) && this.$validate.DataValid(data[this.fieldName])) {
          this.formData.content = data[this.fieldName];
        }
      } catch (err) {
        this.$common.error(err)
      }
    },

    // -- (確認)
    async save() {
      if (!this.$validate.DataValid(this.fieldName)) return;
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const valid = this.$refs['dataForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', { message: 'required' })
        return
      }

      this.$store.dispatch('setLoading', true)
      let payload = {}
      payload[this.fieldName] = this.formData.content;

      try {
        await this.$Fetcher.UpdateSetting(payload)
        this.$store.dispatch('setDataIsUpdated', false)
        this.$store.dispatch('toggleSnack', {
          message: 'message.saveSuccess',
          type: 'success',
          refresh: true,
        })
      } catch (err) {
        this.$common.error(err)
        this.showAlert({
          title: 'message.saveFail',
          message: err,
          isError: true,
        })
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },

    async handleSiteLoaded() {
      this.$store.dispatch('toggleLoadingPage', true)
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: CustomPage')
      this.formData.content = ''
      await this.getSetting()
      this.$store.dispatch('toggleLoadingPage', false)
    },
  },

  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else if (this.$store.getters.dataIsUpdated) {
      this.$store.dispatch('showLeaveAlert', { toLink: { name: to.name } })
      next(false)
    } else {
      next()
    }
  },
}
</script>
